import { render, staticRenderFns } from "./CustomIntegration.vue?vue&type=template&id=73c1c072&scoped=true&"
import script from "./CustomIntegration.vue?vue&type=script&lang=js&"
export * from "./CustomIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c1c072",
  null
  
)

export default component.exports